import React from 'react';
import PropTypes from 'prop-types';

import TipsAndAdvice from '../tips-and-advice';
import EcomCardSlider from '../ecom-card-slider';
import Inspiration from '../../template/window-101/inspiration';
import DynamicArticle from '../dynamic-article';
import DynamicInspiration from '../dynamic-inspiration';
import ArticleSlider from '../article-slider';
import FeaturedArticles from '../featured-articles';
import FAQDynamic from '../faq-dynamic';
import ProjectAside from '../project-aside';
import BeforeAfterCarousel from '../before-after-carousel';

const DynamicComponent = (props) => {
	if (!props.data?.dynamic?.[0]) return null;

	switch (props.data.dynamic[0].card_type) {
		case 'tips advice':
		case 'case-study':
		case 'article':
			return (
				<TipsAndAdvice
					data={props.data}
					dynamic={props.data.dynamic[0]}
					parent={props.parentURL}
					className={props.className || ''}
					hideTitle={props.hideTitle}
				/>
			);
		case 'tile':
			return (
				<EcomCardSlider
					data={props.data}
					dynamic={props.data.dynamic[0]}
					pdpURL={props.parentURL}
					className={props.className || ''}
				/>
			);
		case 'inspiration':
			return (
				<Inspiration
					data={props.data}
					dynamic={props.data.dynamic[0]}
					className={props.className || ''}
					checkDynamic={props.checkDynamic}
				/>
			);
		case 'inspiration-grid':
			return (
				<DynamicInspiration
					data={props.data}
					dynamic={props.data.dynamic[0]}
					className={props.className || ''}
					toggles={props.toggles}
				/>
			);
		case 'projects':
			return (
				<DynamicArticle
					data={props.data}
					count={2}
					dynamic={props.data.dynamic[0]}
					className={props.className || ''}
					parent={props.parentURL}
				/>
			);
		case 'projects-aside':
			return (
				<ProjectAside
					data={props.data}
					dynamic={props.data.dynamic[0]}
					className={props.className || ''}
				/>
			);
		case 'single-article-slider':
			return (
				<ArticleSlider
					data={props.data}
					dynamic={props.data.dynamic[0]}
					className={props.className || ''}
				/>
			);
		case 'featured-articles':
			return (
				<FeaturedArticles
					data={props.data}
					dynamic={props.data.dynamic[0]}
					className={props.className || ''}
				/>
			);
		case 'faq':
			return (
				<FAQDynamic
					data={props.data}
					dynamic={props.data.dynamic[0]}
					className={props.className || ''}
					hideStructuredData={props.hideStructuredData}
					multipleColumns
				/>
			);
		case 'before-after':
			return (
				<BeforeAfterCarousel
					data={props.data}
					dynamic={props.data.dynamic[0]}
					className={props.className || ''}
				/>
			);
		default:
			return null;
	}
};

DynamicComponent.propTypes = {
	data: PropTypes.object.isRequired,
	parentURL: PropTypes.string,
	heading: PropTypes.string,
	className: PropTypes.string,
	hideTitle: PropTypes.bool,
	checkDynamic: PropTypes.func,
	hideStructuredData: PropTypes.bool,
	toggles: PropTypes.object,
};

export default DynamicComponent;
